//chapter1
export default {
    id : 20,//chapter number
    title : '20. PFMEA 작성방법 (7) - PFMEA 최적화',//chapter name
    slides : [
        {
            title : 'Intro',
            type : 'intro',
            source : 'c20.mp4',
        },
        {
            title : 'Today’s Goal',
            type : 'plan',
            body1 : [
                'PFMEA 최적화',
            ],
            body2 : [
                'PFMEA 최적화에 대해 설명할 수 있다.'
            ],
            bgm : "plan.mp3"
        },
        {
            title : 'Lesson',
            type : 'lesson',
            source : '20.mp4',
        },
        {
            title : 'Quiz',
            type : 'quiz',
            quiz : [
                {
                    type : 'ox',
                    question : '조치가 완료되면 AP를 재평가한다.',//html available
                    answer : "1",
                    explain : 'AP의 재평가를 통해 재조치의 판단이 필요하다.'
                },
                {
                    type : 'ox',
                    question : '조치의 효과성이 판단될 때까지 Pending 상태가 계속되어야 한다.',//html available
                    answer : "1",
                    explain : '조치의 효과성이 판단될 때까지 Pending 상태가 계속되어야 한다. 효과성의 판단 후 AP의 평가가 되어야 한다.'
                },
            ],
            quizMask : "../assets/images/quiz_intro.jpg",//quiz mask
            bgm : "quiz.mp3"
        },
        {
            title : 'Summary',
            type : 'summary',
            /*download : 'sample.pptx',//data folder*/
            print : false,// true : show, false: hide
            slides : [
                {
                    body : `<ul>
                        <h3>1. 최적화 개요</h3>
                        <li>위험감소에 필요한 조치에 대한 정의</li>
                        <li>조치에 대한 시간과 목표에 대한 할당과 책임 </li>
                        <li>선택된 조치의 이행과 서류화 </li>
                        <li>이행된 조치에 대한 효과의 확인</li>
                        <li>조치 후 위험의 재평가</li>
                        <li>Process의 지속적 개선 </li>
                        <li>공정의 요구와 예방과 검출 관리의 재정리의 기반</li>
                    </ul>`
                },
                {
                    body : `<ul>
                        <h3>2. 개선조치 F/UP 방안</h3>
                        <p class="mg10"></p>
                        <h3>3. PFMEA 작성연습</h3>
                        <li>가공, 조립공정을 이용한 작성연습</li>
                        <li>공정흐름도, 특성 매트릭스, PFMEA, 관리계획서, 작업지침서 작성</li>
                        <p class="mg10"></p>
                        <h3>4. 양식 사용방법</h3>
                    </ul>`
                },
            ],
            bgm : "summary.mp3"
        },
        {
            title : 'Outro',
            type : 'outro',
            source : 'c20.mp4',
        },
    ]
}